function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0469 13.7385C13.4784 13.7385 13.8281 13.3891 13.8281 12.9582V3.12131C13.8281 1.40022 12.4263 0 10.7031 0H3.125C1.40188 0 0 1.40022 0 3.12131V16.8551C0 18.5762 1.40188 19.9764 3.125 19.9764H10.7031C12.4263 19.9764 13.8281 18.5762 13.8281 16.8551C13.8281 16.4241 13.4784 16.0747 13.0469 16.0747C12.6154 16.0747 12.2656 16.4241 12.2656 16.8551C12.2656 17.7156 11.5647 18.4157 10.7031 18.4157H3.125C2.26344 18.4157 1.5625 17.7156 1.5625 16.8551V3.12131C1.5625 2.26076 2.26344 1.56065 3.125 1.56065H10.7031C11.5647 1.56065 12.2656 2.26076 12.2656 3.12131V12.9582C12.2656 13.3891 12.6154 13.7385 13.0469 13.7385Z",
  fill: "#738BA5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.91406 17.2129C7.34553 17.2129 7.69531 16.8631 7.69531 16.4316C7.69531 16.0002 7.34553 15.6504 6.91406 15.6504C6.48259 15.6504 6.13281 16.0002 6.13281 16.4316C6.13281 16.8631 6.48259 17.2129 6.91406 17.2129Z",
  fill: "#738BA5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.47656 3.55615C8.47656 3.12467 8.1268 2.7749 7.69531 2.7749H6.13281C5.70133 2.7749 5.35156 3.12467 5.35156 3.55615C5.35156 3.98764 5.70133 4.3374 6.13281 4.3374H7.69531C8.1268 4.3374 8.47656 3.9876 8.47656 3.55615Z",
  fill: "#738BA5"
});

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.6884e7dc.svg";
export { ForwardRef as ReactComponent };